export enum DroneTypeEnum {
    VIDEO,
    VIMEO,
    YOUTUBE,
}
